<template>
	<!-- 商品 -->
	<div class="commodity-wrapper">
		<div class="goods-box1">
			<div class="goods-info1">
				<!-- 轮播图 -->
				<info-goods-swipe></info-goods-swipe>
				<!-- 商品信息 -->
				<info-item></info-item>
			</div>
		</div>

		<!-- 促销信息 -->
		<info-promotions></info-promotions>
		<!-- 代金券 -->
		<div class="main-content">
			<flex-line v-if="voucher" :is-link="true" :show-border="true"
				@click.native="$router.push({ name: 'HomeStoreVoucher' })">
				<span>领取优惠券</span>
			</flex-line>
		</div>
		<!-- 店铺服务 -->
		<div class="main-content" v-if="detailInfo.store_service_list && detailInfo.store_service_list.length">
			<flex-line class="field-line" :is-link="true" :show-border="true" @click.native="showService = true">
				<span>店铺服务</span>
				<div class="field-line-right" slot="right">
					<div class="service-list">
						<div class="service-item" v-for="(item, index) in detailInfo.store_service_list" :key="index">
							<span class="service-icon iconfont">&#xe69d;</span>
							<span class="service-text">{{ item.store_service_title }}</span>
						</div>
					</div>
				</div>
			</flex-line>
			<mt-popup v-model="showService" position="bottom">
				<div class="popup-service-list">
					<div class="popup-service-item" v-for="(item, index) in detailInfo.store_service_list" :key="index">
						<div class="service-item">
							<span class="service-icon iconfont">&#xe69d;</span>
							<span class="service-text">{{ item.store_service_title }}</span>
						</div>
						<div class="service-desc">{{ item.store_service_desc }}</div>
					</div>
				</div>
			</mt-popup>
		</div>
		<!-- 购买 -->
		<info-buy></info-buy>
		<!-- 自提-->
		<info-chain></info-chain>
		<!-- 联系客服-->
		<!-- <info-contact></info-contact> -->
		<!-- 店铺保障-->
		<info-translate></info-translate>
		<!-- 参数-->
		<info-attr></info-attr>

		<!-- 评论 -->
		<!-- <info-goods-review @reviewtop='getreviewtop'></info-goods-review> -->

		<!-- 店铺信息 -->
		<!-- <div class="goods-detail-store" @click="$router.push({ name: 'HomeStoredetail', query: { id: storeInfo.store_id } })">
			<div>
				<div class="store-name"><img width="40" :src="storeInfo.store_avatar">
					{{ storeInfo.store_name }}

					<span class="icon-mall" v-if="storeInfo.is_platform_store">自营</span>
				</div>
				<div class="store-rate">
					<span class="equal">描述相符
						<em>{{ storeInfo.store_credit.store_servicecredit.credit }}</em>
						<i>{{ storeInfo.store_credit.store_servicecredit.percent_text }}</i>
					</span>
					<span class="equal">服务态度
						<em>{{ storeInfo.store_credit.store_desccredit.credit }}</em>
						<i>{{ storeInfo.store_credit.store_servicecredit.percent_text }}</i>
					</span>
					<span class="equal">发货速度
						<em>{{ storeInfo.store_credit.store_deliverycredit.credit }}</em>
						<i>{{ storeInfo.store_credit.store_servicecredit.percent_text }}</i>
					</span>
				</div>
			</div>
		</div> -->

		<!-- 商品搭配 -->
		<accessory-item></accessory-item>
		<!-- 商品详情  -->
		<product-desc @mbBodytop="getmbBodytop"></product-desc>
		<!-- 推荐商品  -->
		<!-- <recommend-item></recommend-item> -->
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import flexLine from '../../../flexLine'
import InfoGoodsSwipe from './InfoGoodsSwipe'
import InfoItem from './InfoItem'
import InfoPromotions from './InfoPromotions'
import InfoBuy from './InfoBuy'
import InfoTranslate from './InfoTranslate'
import InfoContact from './InfoContact'
import InfoChain from './InfoChain'
import InfoAttr from './InfoAttr'
import InfoGoodsReview from './InfoGoodsReview'
import RecommendItem from './RecommendItem'
import AccessoryItem from './AccessoryItem'
import ProductDesc from './ProductDesc'
import { flowstat_record } from '../../../../api/homestoredetail'

export default {
	data() {
		return {
			showService: false,
		}
	},

	created() { },

	components: {
		flexLine,
		InfoGoodsSwipe,
		InfoItem,
		InfoPromotions,
		InfoBuy,
		InfoTranslate,
		InfoContact,
		InfoChain,
		InfoAttr,
		InfoGoodsReview,
		RecommendItem,
		ProductDesc,
		AccessoryItem
	},

	computed: {
		...mapState({
			storeInfo: state => state.goodsdetail.storeInfo,
			detailInfo: state => state.goodsdetail.detailInfo,
			voucher: state => state.goodsdetail.voucher
		})
	},
	created() {
		this.flowstat_record()
	},
	mounted() { },

	methods: {
		flowstat_record() {
			flowstat_record(this.storeInfo.store_id, this.detailInfo.goods_id, 'Goods').then((res) => {
			})
		},
		getmbBodytop: function (top) {
			this.$emit('mbBodytop', top);
		},
		getreviewtop: function (top) {
			this.$emit('reviewtop', top);
		}
	}
}
</script>
<style>
.goods-box1 {
	overflow: hidden;
	position: relative;
	width: 1200px;
	background: #fff;
	border-radius: 4px;
	padding: 30px;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	margin: 23px auto 22px !important;
}

.goods-info1 {
	width: 1083px;
	/* height: 482px; */
	padding: 25px;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	background: #fffaf9;
	border-radius: 24px;
	border: 1px solid #f45c1d;
	-webkit-box-align: start;
	-ms-flex-align: start;
	align-items: flex-start;
	display: flex;
}
</style>